import type { ReactNode } from 'react';
import { AgentPicture, AgentPictures } from './AgentPicture';

/** SF-T-266: MentionText's `renderImage` for the agent's messages: the picture where there's a reader, else its link. */
export const showAgentPicture = (src: string, alt: string, link: ReactNode) => <AgentPicture src={src} alt={alt} fallback={link} />;

/** SF-T-266: MentionText's `renderImages`: several pictures in a row as one collage, else as they'd show apart. */
export const showAgentPictures = (pictures: { src: string; alt: string }[], blocks: ReactNode) => <AgentPictures pictures={pictures} fallback={blocks} />;
